import { Variable } from '@kentik/ui-shared/boards/boards';
import { VariableMapping } from '@kentik/ui-shared/boards/panels';
import { Measurement } from '@kentik/ui-shared/query/query.types';
import { getGuidedDimensionOptions, resolveGuidedType } from '@kentik/ui-shared/query/measurements/guidedDimensions';

export function getMissingGuidedVariableMappings(
  variables: Variable[],
  mappedVariableNames: Set<string>,
  measurement: string,
  measurements: Measurement[]
): VariableMapping[] {
  const result: VariableMapping[] = [];

  for (const variable of variables) {
    const needsMapping =
      variable.type === 'guided' && variable.enabled !== false && !mappedVariableNames.has(variable.name);

    if (needsMapping) {
      const guidedType = resolveGuidedType(variable);

      const field = getGuidedDimensionOptions(guidedType, measurement, measurements)[0] ?? variable.field;
      if (field) {
        result.push({ variableName: variable.name, filterField: field });
      }
    }
  }

  return result;
}
